{
    "label": "Structure d'équipe",
    "placeholder": "L'éditeur de la structure d'équipe est en cours de construction."
}
